import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * Shown for any URL that matches no route. The server already answers these
 * with HTTP 404 + noindex (lib/pageRoutes.js); this keeps the page useful
 * instead of rendering an empty layout.
 */
const NotFound = () => (
  <div className="container text-center py-5">
    <Helmet>
      <title>Page not found | Lite Pocket Deals</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <h1 className="h3 mb-3">Page not found</h1>
    <p className="text-muted mb-4">This page doesn&apos;t exist, or the deal has expired.</p>
    <Link to="/" className="btn btn-primary">Browse today&apos;s deals</Link>
  </div>
);

export default NotFound;
